<div class="container">
  <mat-card>
    <form [formGroup]="taxGroupForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div class="layout-row-wrap custom-gap responsive-column">
          <mat-form-field class="flex-fill flex-100">
            <mat-label>{{ 'labels.inputs.Name' | translate }}</mat-label>
            <input matInput required formControlName="name" />
            @if (taxGroupForm.controls.name.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Name' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <h3 class="mat-h3 flex-40">{{ 'labels.inputs.Tax Components' | translate }}</h3>
          <div class="flex-40 layout-row align-start-center">
            <button type="button" mat-raised-button color="primary" (click)="addTaxGroup()">
              <fa-icon icon="plus" class="m-r-10"></fa-icon>
              {{ 'labels.buttons.Add' | translate }}
            </button>
          </div>

          <table mat-table [dataSource]="taxComponentsDataSource" [hidden]="taxComponentsDataSource.length === 0">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Name' | translate }}</th>
              <td mat-cell *matCellDef="let taxComponent">
                {{ taxComponent.taxComponentId | find: taxComponentOptions : 'id' : 'name' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="startDate">
              <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Start Date' | translate }}</th>
              <td mat-cell *matCellDef="let taxComponent">{{ taxComponent.startDate | dateFormat }}</td>
            </ng-container>

            <ng-container matColumnDef="endDate">
              <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.End Date' | translate }}</th>
              <td mat-cell *matCellDef="let taxComponent">
                {{ taxComponent.endDate ? (taxComponent.endDate | dateFormat) : '' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Actions' | translate }}</th>
              <td mat-cell *matCellDef="let taxComponent; let taxComponentIndex = index">
                <button
                  type="button"
                  mat-icon-button
                  color="primary"
                  (click)="editTaxGroup(taxComponent, taxComponentIndex)"
                >
                  <fa-icon icon="edit"></fa-icon>
                </button>
                @if (taxComponent.isNew) {
                  <button
                    type="button"
                    mat-icon-button
                    color="warn"
                    (click)="delete(taxComponentIndex)"
                    matTooltip="{{ 'tooltips.Delete Interest Rate Chart' | translate }}"
                    matTooltipPosition="left"
                  >
                    <fa-icon icon="trash"></fa-icon>
                  </button>
                }
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="!taxGroupForm.valid"
          *LOSxHasPermission="'UPDATE_TAXGROUP'"
        >
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
